import { MapPin, PlaneTakeoff, Building2 } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";

const BOSTON_IMG =
  "https://images.unsplash.com/photo-1565127803082-69dd82351360?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxib3N0b24lMjBza3lsaW5lJTIwY2l0eSUyMGFlcmlhbHxlbnwwfHx8fDE3OTA3ODg0MTh8MA&ixlib=rb-4.1.0&q=85";

const GlobalPresence = () => (
  <section data-testid="global-presence-section" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHead
        eyebrow="Global Presence"
        title="Boston first. The world next."
        lead="A phased expansion model. Prove the platform in our home market, then scale to regions that mirror it."
      />

      <div className="mt-14 grid grid-cols-1 gap-4 md:grid-cols-3">
        <Reveal className="md:col-span-1">
          <div data-testid="presence-card-boston" className="group h-full overflow-hidden border border-line bg-white">
            <div className="treated-hover overflow-hidden">
              <img src={BOSTON_IMG} alt="Boston skyline" className="treated aspect-[16/10] w-full object-cover" loading="lazy" />
            </div>
            <div className="p-7">
              <span className="inline-flex h-10 w-10 items-center justify-center border border-line bg-surface text-accent">
                <MapPin className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <h3 className="mt-5 font-display text-lg font-bold text-charcoal-900">Boston, Massachusetts</h3>
              <p className="mt-2 text-sm leading-relaxed text-steel">
                Headquarters and Phase 1 market, with the densest college and young professional
                live event audience in New England.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.08}>
          <div data-testid="presence-card-trinidad" className="flex h-full flex-col justify-between border border-line bg-charcoal-900 p-7 text-white">
            <div>
              <span className="inline-flex h-10 w-10 items-center justify-center border border-white/15 bg-white/5 text-violet-400">
                <PlaneTakeoff className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <h3 className="mt-5 font-display text-lg font-bold">Trinidad &amp; Tobago</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">
                A high-potential international expansion market with vibrant festival culture,
                underserved digital ticketing infrastructure, and strong appetite for mobile-first
                discovery.
              </p>
            </div>
            <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">Pilot launch: Month 9</div>
          </div>
        </Reveal>

        <Reveal delay={0.16}>
          <div data-testid="presence-card-us-pilots" className="flex h-full flex-col justify-between border border-line bg-surface p-7">
            <div>
              <span className="inline-flex h-10 w-10 items-center justify-center border border-line bg-white text-accent">
                <Building2 className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <h3 className="mt-5 font-display text-lg font-bold text-charcoal-900">Additional US City Pilots</h3>
              <p className="mt-2 text-sm leading-relaxed text-steel">
                Following the Boston model at regional scale, additional US city pilots begin in
                month ten, backed by infrastructure scaling.
              </p>
            </div>
            <div className="mt-6 font-mono text-[10px] uppercase tracking-[0.2em] text-steel/70">Expansion: Month 10</div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default GlobalPresence;
